export const getClampedLeftValue = (
  initialVal: number | undefined,
  boundsLeft: number | undefined,
  boundsRight: number | undefined
): number => {
  if (!initialVal || !boundsLeft || !boundsRight) return 0;

  const offset = 10;

  if (initialVal < boundsLeft) return boundsLeft + offset;
  if (initialVal > boundsRight) return boundsRight - offset;
  return initialVal;
};

export const getRelativeParentDomRect = (
  element: SVGElement | null
): DOMRectReadOnly | null => {
  if (!element) return null;
  const parentElement = element.ownerSVGElement?.parentElement;

  if (!parentElement) return null;

  const elementRect = element.getBoundingClientRect();
  const parentRect = parentElement.getBoundingClientRect();

  const elementLeft = elementRect.left - parentRect.left;

  return {
    ...elementRect,
    left: elementLeft,
    right: elementLeft + elementRect.width,
    x: elementLeft,
  };
};
